import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input, OnDestroy, OnInit,
  Output,
  ViewRef
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {FroalaEditorModule, FroalaViewModule} from "angular-froala-wysiwyg";
import {LabelInputSearchComponent} from "../label-input-search/label-input-search.component";
import {ClickOutsideDirective} from "../../../directives/click.outside";
import {CollaborationService} from "../../../services/Collaboration.service";
import {ToastService} from "../../../services/Toast.service";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {DateFormater} from "../../../services/DateFormatter.service";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../../services/Session";
import {LinkyModule} from "ngx-linky";

declare let _: any;
declare let jQuery: any;
declare let moment: any;

@Component({
  selector: 'app-sub-comment',
  standalone: true,
  imports: [CommonModule, FormsModule, FileUploadModule, FroalaEditorModule, FroalaViewModule, LabelInputSearchComponent, ClickOutsideDirective,
    LinkyModule],
  templateUrl: './sub-comment.component.html',
  styleUrl: './sub-comment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubCommentComponent implements OnInit, OnDestroy {
  filters: any = {'task': '#4ab9e8', 'done': '#1CB3AB', 'working': '#FDB844', 'active': '#CD0814', 'celebrating': '#ef655d'};
  comments: any;
  selectedCommentInput: string;
  user: any;
  updateOptions = ['update', 'delete'];

  public uploader: FileUploader;
  postUploadResp: any = [];
  posts: any = [];
  updateObj: any = {};
  entityType: string;
  routeSub: any;
  selectedCommentToggle: string;
  generatedId: string;

  @Input()
  set data(data: any) {
    let base = this;
    _.each(data, function (comment) {
      comment.tooltipDate = base.updateDateTimeStamp(comment.createdDate);
      comment.displayDate = base.updateDateTimeStampForTooltip(comment.createdDate);
    });
    this.comments = data;
  }

  @Input() taskId: string;
  @Input() companyId: string;
  @Input() comment: any;
  @Input() pageType: string;
  @Input() channelType: string;
  @Input() org: string;
  @Input() clientInternalUsers: any;

  uploadCount = 0;
  documentName: string;
  documentNotes: string = '';
  currentUpdatingDocument: any;
  currentDocumentFolderInfo: any;
  currentDocPostOrComment: any;
  sourceType: any;
  uploadingDocumentName: string;
  uploadingDocumentNotes: string = '';
  isQountOrgUser: boolean = false;
  placeHolder: string = 'Write A comment';
  reveal: any = {
    onMove: false,
    documentUpload: false,
    mailAttach: false
  };
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  messageHeight: boolean = true;
  selectedComment: any = {};
  @Output() onSubCommentFolderClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDeleteSubComment: EventEmitter<any> = new EventEmitter<any>();

  users: Array<any> = [];
  allUsers: Array<any> = [];
  showMentionDropdown: boolean = false;
  mentionUsers: Array<any> = [];
  mentionIds: Array<any> = [];
  mentions: Array<any> = [];
  subcommentMsg: string = '';
  documentsIds: Array<any> = [];
  documentsData: Array<any> = [];
  docData: Array<any> = [];

  constructor(private loadingService: LoadingService,
              private collaborationService: CollaborationService,
              private switchBoard: SwitchBoard,
              private toastService: ToastService,
              private dateFormater: DateFormater,
              private changeDetectorRef: ChangeDetectorRef,
              private taxStrategyServices: ManageTaxStrategiesServices) {
  }

  ngOnInit(): void {
    this._init();
  }

  _init() {
    this.users = Session.getUsers() || [];
    this.user = Session.getUser();
    this.isQountOrgUser = !this.user.isCustomer;
    this.placeHolder = this.taskId ? 'Make A note' : 'Write A comment';
    this.generatedId = this.guid();
    this.uploaderUpdate();
    this.buildItemForm();

    this.switchBoard.onRevealClose.pipe(takeUntil(this.destroy$)).subscribe(next => {
      this.docData = [];
      this.documentsIds = [];
      this.documentsData = [];
      this.hideReveal(next);
    });
  }

  uploaderUpdate() {
    let docUrl = this.taxStrategyServices.getDocumentServiceUrl(this.org, this.user.id);
    this.uploader = new FileUploader(<FileUploaderOptions>{
      url: docUrl,
      headers: [
        {
          name: 'Authorization',
          value: 'Bearer ' + Session.getToken()
        }
      ]
    });
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  buildItemForm() {
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      let payload: any = {};
      payload.sourceID = this.generatedId;
      payload.sourceType = (this.channelType == 'orgs') ? 'BROADCAST_POST_COMMENT' : 'TODO_POST_COMMENT';
      form.append('payload', JSON.stringify(payload));
    };
    this.postUploadResp = [];
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploadCount++;
        this.postUploadResp = [...this.postUploadResp, JSON.parse(response)];
        this.uploader.progress = 100;
        if (this.uploader.queue.length === this.uploadCount) {
          this.toastService.pop(TOAST_TYPE.success, 'Uploaded Successfully');
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
        } else {
          this.toastService.pop(
            TOAST_TYPE.success,
            this.uploadCount +
            '/' +
            this.uploader.queue.length +
            ' Uploaded Successfully'
          );
          this.loadingService.triggerLoadingEvent(false);
        }
      } else {
        this.toastService.pop(TOAST_TYPE.error, 'Error While Uploading');
        this.uploadCount++;
        if (this.uploader.queue.length === this.uploadCount) {
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
        }
      }
    };
  }

  hideReveal(revealFlag) {
    this.reveal[revealFlag] = false;
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  getCommentTime(date) {
    let startTime = moment.utc(date).toDate();
    startTime = moment(startTime).format('YYYY-MM-DD HH:mm:ss');
    const duration = moment(startTime).fromNow();
    return moment(startTime).calendar(null, {
      sameDay: function (now) {
        if (this.isBefore(now)) {
          return '[' + duration + ']';
        } else {
          return moment(startTime).calendar();
        }
      },
      lastDay: function () {
        return '[Yesterday]';
      },
      lastWeek: 'MM/DD/YYYY',
      sameElse: 'MM/DD/YYYY'
    });
  }

  getDateTimeStamp(date) {
    let serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    let dateFormat = 'MM/DD/YYYY HH:mm:ss';
    let startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  getColor(type) {
    return this.filters[type];
  }

  getRight(index) {
    return index * 5 + 'px';
  }

  showCommentInput(id) {
    if (this.selectedCommentInput === 'comment_' + id) {
      this.selectedCommentInput = '';
    } else {
      this.selectedCommentInput = 'comment_' + id;
    }
  }

  handleCommentAction(action, comment, postId) {
    this.selectedComment = comment;
    if (action === 'delete') {
      this.deleteComment(comment, postId);
    } else {
      this.updateComment(comment, postId);
    }
  }

  updateComment(comment, postId) {
    this.updateObj = _.clone(comment);
  }


  deleteComment(comment, postId) {
    this.collaborationService.deleteComment(comment.id, postId)
      .subscribe(response => {
        this.onDeleteSubComment.emit(comment.id);
      }, error => {
      });
  }

  onSubCommentEnter(event, comment) {
    let base = this;
    if (this.postUploadResp.length > 0 || (event && event.target.value.length > 0) || this.documentsIds.length > 0) {
      let newComment: any = {
        'user': {
          'firstName': this.user.first_name,
          'lastName': this.user.last_name,
          'id': this.user.id,
          'colorCode': this.user.colorCode,
          'bot': false,
          'thumbnail':  this.user?.thumbnail?.length > 0 ? this.user.thumbnail : '',
        },
        'orgId': Session.getOrg(),
        'commentedBy': this.user.id,
        'message': (event && event.target.value) ? event.target.value : '',
        'postID': comment.postID,
        'postInternal': comment.postInternal,
        'parentID': comment.id,
        'children': [],
        'browserTimeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'documents': [],
        'mentionIds': []
      };
      if (this.postUploadResp.length > 0) {
        for (let i in this.postUploadResp) {
          let obj = {
            'name': this.postUploadResp[i].name,
            'id': this.postUploadResp[i].id,
            'temporaryURL': this.postUploadResp[i].temporaryURL,
            'doc_notes': this.postUploadResp[i].documentNotes
              ? this.postUploadResp[i].documentNotes
              : ''
          };
          newComment.documents = [...newComment.documents, obj];
        }
        newComment = {...newComment, id: this.postUploadResp[0].sourceID};
      } else {
        newComment = {...newComment, id: this.guid()};
      }
      if (this.documentsIds.length > 0) {
        newComment['documents'] = [...newComment['documents'], ...this.documentsIds];
      }
      comment.children = [...comment.children, newComment];
      if (event) {
        event.target.value = '';
      }
      this.prependMentions(newComment);
      this.resetNewSubCommentField();
      this.collaborationService.createComment(this.org, this.channelType, newComment, this.companyId, comment.postID, this.taskId).pipe(
        takeUntil(this.destroy$))
        .subscribe(
          response => {
            this.handleCommentCreation(comment, response);
          },
          error => {
            this.handleCommentCreationFailure(comment, error);
          }
        );
    }
  }

  handleCommentCreationFailure(comment, error) {
    this.postUploadResp = [];
    comment.children.splice(-1, 1);
    this.toastService.pop(
      TOAST_TYPE.error,
      'Failed To Post'
    );
  }

  handleCommentCreation(comment, response) {
    let responseObj = response;
    let index = _.findIndex(comment.children, function (cmt) {
      return cmt.id === responseObj.id;
    });
    comment.children[index] = responseObj;
    this.resetUploader();
  }

  resetNewSubCommentField() {
    this.messageHeight = false;
    this.selectedCommentInput = '';
    this.generatedId = '';
    this.mentionIds = [];
    this.mentions = [];
    this.allUsers = [];
    this.postUploadResp = [];
    this.docData = [];
    this.documentsData = [];
    this.documentsIds = [];
    setTimeout(() => {
      this.messageHeight = true;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  updateDateTimeStamp(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  updateDateTimeStampForTooltip(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  guid() {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
      this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }

  showCommentToggle(id) {
    if (this.selectedCommentToggle === 'commentToggle' + id) {
      this.selectedCommentToggle = '';
    } else {
      this.selectedCommentToggle = 'commentToggle' + id;
    }
  }

  startUpload($event, id?: string) {
    const base = this;
    if (this.uploader.queue.length > 1) {
      setTimeout(() => {
        base.uploader.uploadAll();
      }, 400);
    } else {
      this.uploader.queue.forEach(function (item) {
        base.uploadingDocumentName = item.file.name;
      });
      this.uploadDocument();
      this.changeDetectorRef.detectChanges();
    }
  }

  onUpdateEnter(type) {
    let base = this;
    if (this.postUploadResp.length > 0) {
      this.updateObj['documents'] = [];
      for (let i in this.postUploadResp) {
        let obj = {};
        obj['name'] = this.postUploadResp[i].name;
        obj['id'] = this.postUploadResp[i].id;
        obj['doc_notes'] = (this.postUploadResp[i].documentNotes) ? this.postUploadResp[i].documentNotes : '';
        this.updateObj.documents.push(obj);
      }
    }
    this.collaborationService.updateComment(this.org, this.channelType, this.updateObj, type, this.companyId)
      .subscribe(response => {
        let responseObj = this.updateObj;
        let CommentObj = _.filter(this.comments, {id: base.updateObj.id})[0];
        let index = _.findIndex(this.comments, function (comment) {
          return comment.id === base.updateObj.id;
        });
        responseObj['children'] = CommentObj.children;
        this.comments[index] = responseObj;
        this.updateObj = {};
        this.postUploadResp = [];
        this.generatedId = '';
        this.selectedComment = {};
      }, error => {
      });
  }

  deleteAttachment(attachmentId, obj?) {
    this.collaborationService.removeAttachment(this.org, this.channelType, attachmentId, this.companyId)
      .subscribe(response => {
        if (obj) {
          _.remove(obj.documents, {id: attachmentId});
        } else {
          _.remove(this.postUploadResp, {id: attachmentId});
          if (this.postUploadResp.length === 0) {
            this.resetUploader();
          }
        }
      }, error => {
        let errorObj = JSON.parse(error);
        if (errorObj.message) {
          this.toastService.pop(TOAST_TYPE.error, JSON.parse(error).message);
        } else {
          this.toastService.pop(TOAST_TYPE.error, 'Failed To Delete Attachment');
        }
      });
  }

  ngOnDestroy() {
    if (jQuery('#comment-doc-update-conformation')) {
      jQuery('#comment-doc-update-conformation').remove();
    }
    if (jQuery('#collaboration-comment-upload')) {
      jQuery('#collaboration-comment-upload').remove();
    }
    jQuery('.post_options').unbind();
    this.destroy$.next();
    this.destroy$.complete();
  }


  /*file drop functionality*/

  fileDropOver($event, id?: string) {
    let base = this;
    if (this.uploader.queue.length > 1) {
      setTimeout(function () {
        base.uploader.uploadAll();
      }, 400);
    } else {
      this.uploader.queue.forEach(function (item) {
        base.uploadingDocumentName = item.file.name;
      });

      setTimeout(function () {
        base.openUploadModalDailog();
      }, 400);
    }
  }

  openUploadModalDailog() {
    jQuery('#collaboration-comment-upload').foundation('open');
  }

  closeUploadModalDailog() {
    this.uploader.queue = [];
    this.uploadingDocumentName = '';
    this.uploadingDocumentNotes = '';
    jQuery('#collaboration-comment-upload').foundation('close');
  }

  uploadDocument() {
    const base = this;
    this.uploader.queue.forEach(function (item) {
      item.file.name = base.uploadingDocumentName;
    });
    this.uploader.uploadAll();
    this.loadingService.triggerLoadingEvent(true);
  }

  resetUploader() {
    this.uploader.queue.forEach(function (item) {
      item.remove();
    });
  }

  cancelUpload(obj) {
    this.uploader.queue.forEach(function (item) {
      if (item._file.name === obj._file.name) {
        item.remove();
      }
    });
  }

  invokeTimeago() {
    jQuery('.post_options').on('mouseover', function ($event) {
      jQuery(this).siblings().css('display', 'inline');
    });
  }

  openPopUpForUpdateDocument(attachment, doc, postOrComment, type) {
    this.currentUpdatingDocument = attachment;
    this.currentDocumentFolderInfo = doc;
    this.documentName = attachment.name;
    this.documentNotes = (attachment.doc_notes) ? attachment.doc_notes : '';
    this.currentDocPostOrComment = postOrComment;
    this.sourceType = type;
    jQuery('#comment-doc-update-conformation').foundation('open');
  }

  stopPropagation($event) {
    $event && $event.stopImmediatePropagation();
  }

  triggerFileUpload(comment) {
    jQuery('#subcomment-' + comment.id).click();
    this.selectedComment = comment;
  }

  stopEditing() {
    this.updateObj = {};
    setTimeout(() => {
      this.invokeTimeago();
    });
  }

  onSubFolderCommentClicked(attach, comment) {
    this.onSubCommentFolderClick.emit({
      attach: attach,
      comment: comment,
      type: 'Subcomment'
    });
  }

  showMentionWidget() {
    this.allUsers = [...this.users];
    this.mentionUsers = [...this.users];
    this.mentionUsers.unshift({id: 'All', name: 'All'});
    setTimeout(() => {
      this.showMentionDropdown = true;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  closeMentionContainer() {
    this.showMentionDropdown = false;
  }

  mentionSelected($event) {
    if ($event && $event.id == 'All') {
      this.mentionIds = [{id: 'All', name: 'All'}];
      this.mentions = ['All'];
    } else if ($event) {
      let index = _.findIndex(this.mentionIds, {id: $event.id});
      if (index == -1) {
        this.mentionIds = [...this.mentionIds, $event];
        this.mentions = _.map(this.mentionIds, 'name');
      }
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  removeMention($event) {
    if ($event && $event.id == 'All') {
      this.mentionIds = [];
      this.mentions = _.map(this.mentionIds, 'name');
    } else if ($event) {
      let index = _.findIndex(this.mentionIds, {id: $event.id});
      if (index !== -1) {
        this.mentionIds = this.mentionIds.filter((entry, idx) => {
          return index != idx;
        });
      }
      this.mentions = _.map(this.mentionIds, 'name');
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  prependMentions(newComment) {
    const base = this;
    if (this.mentionIds.length > 0) {
      if (this.mentionIds[0].id == 'All') {
        this.mentionIds = [...this.allUsers];
      }
      let mentionString = _.map(this.mentionIds, function (mention) {
        return `@${mention.name}`;
      });
      newComment.mention_message = `${mentionString}:`;
      if (this.pageType == 'teams') {
        newComment.mentionIds = _.map(this.mentionIds, 'userId');
      } else {
        newComment.mentionIds = _.map(this.mentionIds, 'id');
      }
    }
  }

  handleEmojiSelection(event) {
    this.subcommentMsg += event.char;
  }

  removeDocument(doc) {
    let base = this;
    for (let i = 0; i < base.documentsData.length; i++) {
      if (base.documentsData[i]['id'] === doc.id) {
        base.documentsIds.splice(i, 1);
        base.documentsData.splice(i, 1);
      }
    }
  }

  attachFromDocs(document) {
    this.docData = document.documentsData;
    for (let i = 0; i < this.docData.length; i++) {
      this.documentsData.push(this.docData[i]);
      let obj = {
        id: this.docData[i]['file'].id,
        name: this.docData[i]['file'].name,
      };
      this.documentsIds.push(obj);
    }
    this.hideReveal('mailAttach');
  }

  hidePostOptions() {
    jQuery('.post_options')
      .siblings()
      .hide();
  }

}
